import React from 'react';

const Benefit = () => {
  return (
    <section className="section work-section-six">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-xxl-3 col-lg-4">
                    <div className="section-header-six mb-0 wow fadeInUp" data-wow-delay="1.5">
                        <span className="badge badge-soft-primary rounded-pill mb-1">Cách hoạt động</span>
                        <h2>Quy trình đặt tour của chúng tôi diễn ra như thế nào<span className="text-primary">.</span></h2>
                    </div>
                </div>
                <div className="col-xxl-9 col-lg-8">
                    <div className="row align-items-center">
                        <div className="col-md-4 col-sm-6">
                            <div className="bg-teal-trans mb-4 wow fadeInUp" data-wow-delay="1.5">
                                <div className="card border-0 mb-0">
                                    <div className="card-body">
                                        <div className="d-flex align-items-center justify-content-between mb-3">
                                            <span className="work-icon text-teal d-flex"><i className="isax isax-buildings-25"></i></span>
                                            <span className="work-avatar">
												01
											</span>
                                        </div>
                                        <div>
                                            <h5 className="mb-2 text-truncate">Kiểm tra tình trạng tour</h5>
                                            <p className="text-truncate line-clamb-3">Đảm bảo rằng tour còn chỗ vào ngày bạn muốn đi. Xem danh sách các tour có sẵn tại điểm đến.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-6">
                            <div className="bg-prime-trans mb-4 wow fadeInUp" data-wow-delay="1.5">
                                <div className="card border-0 mb-0">
                                    <div className="card-body">
                                        <div className="d-flex align-items-center justify-content-between mb-3">
                                            <span className="work-icon text-primary d-flex"><i className="isax isax-calendar-edit5"></i></span>
                                            <span className="work-avatar">
												02
											</span>
                                        </div>
                                        <div>
                                            <h5 className="mb-2 text-truncate">Đặt tour &amp; Xác nhận</h5>
                                            <p className="text-truncate line-clamb-3">Sau khi đặt tour, bạn sẽ nhận được xác nhận. Đến quầy lễ tân khi đến nơi để làm thủ tục check-in.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-6">
                            <div className="bg-purple-trans mb-4 wow fadeInUp" data-wow-delay="1.5">
                                <div className="card border-0 mb-0">
                                    <div className="card-body">
                                        <div className="d-flex align-items-center justify-content-between mb-3">
                                            <span className="work-icon text-purple d-flex"><i className="isax isax-direct-send5"></i></span>
                                            <span className="work-avatar">
												03
											</span>
                                        </div>
                                        <div>
                                            <h5 className="mb-2">Thưởng thức chuyến đi</h5>
                                            <p className="text-truncate line-clamb-3">Hãy có mặt đúng giờ tại điểm hẹn, đặt câu hỏi nếu cần và tận hưởng hành trình tuyệt vời!</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  );
};

export default Benefit;
